import React, { useState, useRef, useEffect } from "react";
import TBBImage from "utils/TBBImage";
import RichText from "utils/RichText";

const WorkHeader = ({ blok }) => {
  const containerRef = useRef();

  const [progress, setProgress] = useState(0);
  const [scrollTop, setScrollTop] = useState(0);

  useEffect(() => {
    let currentPosition = window.pageYOffset;
    const { height } = containerRef.current.getBoundingClientRect();
    function onScroll() {
      currentPosition = window.pageYOffset;
      if (currentPosition < height + 1000) {
        setProgress(currentPosition);
      }
      setScrollTop(currentPosition <= 0 ? 0 : currentPosition);
    }

    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [scrollTop]);

  return (
    <div className="relative overflow-hidden">
      {!blok.asset.filename?.includes(".mp4") && blok.asset.filename && (
        <TBBImage
          image={blok.asset}
          className={`h-full w-full object-cover ${
            blok.mobile_asset.filename && "hidden md:block"
          }`}
        />
      )}
      {!blok.mobile_asset.filename?.includes(".mp4") &&
        blok.mobile_asset.filename && (
          <TBBImage
            image={blok.mobile_asset}
            className={`block h-full w-full object-cover md:hidden`}
          />
        )}
      {blok.asset.filename?.includes(".mp4") && blok.asset.filename && (
        <div className="block h-full w-full object-cover">
          <video
            width="1920"
            height="1080"
            muted
            controlsList="nodownload"
            autoPlay
            loop
            playsInline
            className={`${
              blok.mobile_asset.filename?.includes(".mp4")
                ? "hidden md:block"
                : "block"
            } h-full w-full object-cover`}
          >
            <source src={blok.asset.filename} type="video/mp4" />
            Sorry, your browser doesn't support embedded videos.
          </video>
          {blok.mobile_asset.filename?.includes(".mp4") &&
            blok.mobile_asset.filename && (
              <video
                width="1920"
                height="1080"
                muted
                controlsList="nodownload"
                autoPlay
                loop
                playsInline
                className="block h-full w-full object-cover md:hidden "
              >
                <source src={blok.mobile_asset.filename} type="video/mp4" />
                Sorry, your browser doesn't support embedded videos.
              </video>
            )}
        </div>
      )}
      <div className="absolute inset-0 my-12 flex items-center overflow-hidden lg:my-24">
        <div className="m-auto px-6 lg:px-12" ref={containerRef}>
          {/* Animated  */}
          {blok.title &&
            blok.title.content?.map((items, index) =>
              items.content?.map((item) => (
                <div className="flex">
                  <h1
                    style={
                      index % 2 == 0
                        ? { transform: `translateX(${progress / 10}%)` }
                        : { transform: `translateX(-${progress / 10}%)` }
                    }
                    className={`relative ${
                      index % 2 == 0
                        ? "left-[-50%] mr-auto"
                        : "right-[-50%]  ml-auto"
                    } tranisition  font-poppins font-display !mb-6 flex-none !text-[80px] leading-none tracking-normal text-white lg:!text-[13vw] `}
                  >
                    <RichText>{item.text}</RichText>
                  </h1>
                </div>
              ))
            )}
        </div>
      </div>
    </div>
  );
};

export default WorkHeader;
